module.exports = __webpack_public_path__ + "img/new_vertical_illustration.1a566106.png";